import { initialTaskState, actions } from "./action";

export const taskReducer = (state = initialTaskState, action) => {
    switch (action.type) {
        case actions.TASK_GET_ALL_SUCCESS:
            return {
                ...state,
                taskList: Array.isArray(action.payload) ? action.payload : []
            };
        case actions.TASK_GET_ALL_FAILURE:
            return {
                ...state,
                taskList: []
            };
        case actions.TASK_CREATE_SUCCESS:
            return {
                ...state,
                task: action.payload
            };
        case actions.TASK_DELETE_SUCCESS:
            return {
                ...state,
                task: action.payload?.id ? {...action.payload, action: 'delete'} : {}
        };
        case actions.TASK_COPY_SUCCESS:
            return {
                ...state,
                task: action.payload?.id ? {...action.payload, action: 'copy'} : {}
        };
        case actions.TASK_CREATE_FAILURE:
            return {
                ...state,
                task: {}
            };
        case actions.TASK_UPDATE_SUCCESS:
            return {
                ...state,
                task: action.payload
            };
        case actions.TASK_UPDATE_FAILURE:
            return {
                ...state,
                task: {}
            };
        case actions.TASK_RESET_SUCCESS:
            return {
                ...state,
                task: {}
            };
        case actions.TASKTAG_GET_ALL_SUCCESS:
            return {
                ...state,
                taskTagList: Array.isArray(action.payload) ? action.payload : []
            };
        case actions.TASKTAG_GET_ALL_FAILURE:
            return {
                ...state,
                taskTagList: []
            };
        case actions.TASKTAG_CREATE_SUCCESS:
            return {
                ...state,
                taskTag: action.payload
            };
        case actions.TASKTAG_CREATE_FAILURE:
            return {
                ...state,
                taskTag: {}
            };
        case actions.TASKTAG_UPDATE_SUCCESS:
            return {
                ...state,
                taskTag: action.payload
            };
        case actions.TASKTAG_UPDATE_FAILURE:
            return {
                ...state,
                taskTag: {}
            };
        case actions.TASKTAG_RESET_SUCCESS:
            return {
                ...state,
                taskTag: {}
            };   
        default:
            return state;
    }
};
